import { EntidadeBase } from 'hay-core-react';
class ConfiguracaoModel extends EntidadeBase {
  constructor() {
    super('configuracao');
  }
}

export default new ConfiguracaoModel();
